import {IEventbusEvent} from "OK/EventBus";

export interface IInvocationItemBase {
    context?: object;
    handler: EventListener;
    once: boolean;
}

class OkEvent {
    list: Array<IInvocationItemBase> = [];

    static wrapMethod = (handler: EventListener, context?: object): IInvocationItemBase => {
        return {
            context: context,
            handler: handler,
            once: false,
        };
    }

    private _callHandler<TData>(
        handler: EventListener,
        eventArgs: IEventbusEvent<TData>,
        handlerContext?: object,
    ) {
        handler.call(handlerContext, eventArgs);
        return this;
    }

    trigger<TData>(eventArgs: IEventbusEvent<TData>): OkEvent {
        const self = this;
        const invocationList = self.list.slice();
        //use eventArg2 for extends _callHandler, not copy args because https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
        const eventArg2 = arguments[1];
        const onceList = [];

        for (let i = 0, l = invocationList.length; i < l; i++) {
            const invocationItem = invocationList[i];
            //fix for attach once. TODO add correct processing add and remove handler at trigger processing time
            if (invocationItem) {
                if (invocationItem.once) {
                    onceList.push(invocationItem);
                }
                self._callHandler(invocationItem.handler, eventArgs || eventArg2, invocationItem.context);
            }
        }

        onceList.forEach(function (onceItem) {
            const i = self.list.indexOf(onceItem);
            if (i !== -1) {
                self.list.splice(i, 1);
            }
        });

        return self;
    }

    attach(handler: EventListener, context?: object): OkEvent {
        const self = this;
        self.list.push(OkEvent.wrapMethod(handler, context));
        return self;
    }

    attachOnce(handler: EventListener, context?: object): OkEvent {
        const self = this;
        const invocationItem = OkEvent.wrapMethod(handler, context);

        invocationItem.once = true;
        self.list.push(invocationItem);

        return self;
    }

    detach(handler: EventListener, context?: object): OkEvent {
        const self = this;

        const list = self.list;
        let i = list.length;

        while (i-- > 0) {
            const invocationItem = list[i];
            if (invocationItem.handler === handler && invocationItem.context === context) {
                list.splice(i, 1);
            }
        }

        return self;
    }
}

export const eventFactory = {
    create: () => {
        return new OkEvent();
    }
}
